import React from 'react';
import { Link } from 'react-router-dom';

const Relational = () => {
    return (
        <div className="page-container relational-page">
            <h1 className="page-title">Relational Well-being</h1>

            {/* Include the image */}
            <img
                src="/images/wf-relational2.jpg" // Path to image in public folder
                alt="Person meditating"
                className="page-image"
            />

            <p className="page-intro">
                Welcome to the Relational Well-Being section of Wholeness Forward.
            </p>
            
            <p className="page-text">
                Relational well-being refers to the quality and depth of our connections with others. 
                It encompasses our relationships with family, friends, romantic partners, colleagues, and the broader community. 
                Healthy relationships are fundamental to our overall well-being, providing support, love, and a sense of belonging.
            </p>
            <p className="page-text">
                In this context, relational well-being goes beyond just social interaction—it’s about cultivating meaningful and supportive connections that nurture us. 
                Positive relationships can help reduce stress, enhance emotional resilience, and foster personal growth. 
                Strengthening these connections is an essential part of leading a fulfilling life.
            </p>

            <hr className="page-divider" />

            <p className="page-text">
                At Wholeness Forward, we offer resources to help you build and nurture meaningful relationships. 
                Whether you're strengthening existing bonds or looking to cultivate new connections, we are here to support your relational well-being journey.
            </p>

            <h2 className="page-heading">Subtopics</h2>
            <ul className="content-list">
                
                <li><Link to="/relational/communication" className="content-link">Effective Communication</Link></li>
                  <ul className="content-list">
                        <li><Link to="/relational/listening" className="content-link">Active Listening</Link></li>
                        <li><Link to="/relational/speaking" className="content-link">Speaking with Clarity</Link></li>
                      </ul>
                <li><Link to="/relational/relationships" className="content-link">Building Healthy Relationships</Link></li>     
                <li><Link to="/relational/conflictresolution" className="content-link">Conflict Resolution</Link></li>
                {/* <li>Building Empathy</li>
                <li>Social Support Networks</li> */}
            </ul>

            <hr className="page-divider" />

            <h3 className="subheading">Community Relational Discussion</h3>
            <p className="page-text">
                Join the conversation and connect with others working on their relational well-being. Share experiences, ask questions, and gain insights from community members. 
                Whether you're building stronger connections with loved ones or exploring new social circles, this is the place for you.
            </p>
            <a href="/forum/Relational" className="btn">Join the Forum</a>
        </div>
    );
};

export default Relational;
